import React from "react";

import Info from "./Info";

import EditCard from "uicomponents/EditCard";

import { sectionsQuestions } from "pages/WorkersCompApplcation/utils/sectionsQuestions";
import { AppDocumentType, EmployeeCompanyInformationType } from "types";

interface IDocumentsReviewProps {
  data: EmployeeCompanyInformationType;
  setActiveStepIndex: (index: number) => void;
  sectionNumber: number;
  documents: AppDocumentType;
}

const DocumentsReview = ({
  data,
  setActiveStepIndex,
  sectionNumber,
  documents,
}: IDocumentsReviewProps): JSX.Element => {
  if (!data) {
    return <></>;
  }

  const questions = Object.entries(sectionsQuestions["documents"].questions);

  const getAnswer = (data?: EmployeeCompanyInformationType, key?: any) => {
    const answerHasDocument = documents?.find(
      (item) => item.applicationField === key
    );
    return answerHasDocument
      ? answerHasDocument?.fileName
      : data?.[key as keyof EmployeeCompanyInformationType];
  };
  return (
    <EditCard
      title={`${sectionsQuestions.documents.title}`}
      onEditClick={() => setActiveStepIndex(sectionNumber)}
    >
      {questions.map(([key, value]) => {
        return (
          <Info
            key={key}
            question={value}
            answer={getAnswer(data, key)}
            questionFieldName={key}
          />
        );
      })}
    </EditCard>
  );
};

export default DocumentsReview;
